import { GAME_TYPE } from 'constants/enums/GameTypeEnum'

import { palette } from 'theme/palette'

const styles = {
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: 'black',
				opacity: '23%',
			},
		},
	},
	inputLabel: {
		color: 'black',
		opacity: '23%',
	},
	linkModal: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '80%',
		maxWidth: '822px',
		bgcolor: 'background.paper',
		border: '2px transparent',
		borderRadius: '30px',
		boxShadow: 24,
		p: 4,
	},
}

const setChipColor = (gameTypeValue: number | undefined) => {
	const colorHexCode = '#fff'
	switch (gameTypeValue) {
		case GAME_TYPE.BATTLE_SHIPS.value:
			return palette.chipColor.battleships.main
		case GAME_TYPE.DRESS_UP.value:
			return palette.chipColor.dressup.main
		case GAME_TYPE.TEETER_TOTTER.value:
			return palette.chipColor.teeterTotter.main
		case GAME_TYPE.OPPOSITE_DAY.value:
			return palette.chipColor.oppositeDay.main
		case GAME_TYPE.BUILDING_BLOCKS.value:
			return palette.chipColor.buildingBlocks.main
		case GAME_TYPE.MUSICAL_CHAIRS.value:
			return palette.chipColor.musicalChairs.main
		default:
			return colorHexCode
	}
}

export { styles, setChipColor }
